import _ from 'lodash';

export const isNumeric = (value) => !Number.isNaN(_.toNumber(value));
